import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import PasswordChangeView from './view/index.js';
import { connect } from 'react-redux';
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const { selectPasswordChangeState } = MojitoServices.Authentication.selectors;

class PasswordChange extends UIViewImplementation {
    render() {
        return <PasswordChangeView passwordChangeState={this.props.passwordChangeState} />;
    }
}

const mapStateToProps = state => ({ passwordChangeState: selectPasswordChangeState(state) });
export default connect(mapStateToProps)(PasswordChange);
